function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 431,
  height: 255
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.6
}, /*#__PURE__*/React.createElement("rect", {
  width: 431,
  height: 254.734,
  rx: 20,
  fill: "#0D5ED7"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("rect", {
  opacity: 0.2,
  x: -202,
  y: 232.548,
  width: 237.635,
  height: 338.826,
  transform: "rotate(-47.6234 -202 232.548)",
  fill: "white"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.6
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 418,
  height: 255
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 20C0 8.95431 8.95431 0 20 0H398C409.046 0 418 8.95431 418 20V234.734C418 245.779 409.046 254.734 398 254.734H20C8.95432 254.734 0 245.779 0 234.734V20Z",
  fill: "#ED982F"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1)"
}, /*#__PURE__*/React.createElement("rect", {
  opacity: 0.1,
  width: 186.163,
  height: 235.623,
  transform: "matrix(0.662675 -0.748907 0.728354 0.685201 -143 261.419)",
  fill: "white"
})));

var SvgMaskShadow = function SvgMaskShadow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 431,
    height: 255,
    viewBox: "0 0 431 255",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaskShadow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mask-shadow.ccecce85.svg";
export { ForwardRef as ReactComponent };